import React from 'react';
import { Phone, PhoneOff, Volume2, VolumeX } from 'lucide-react';
import { AppError } from '../hooks/useAudioRecording';

interface CallInterfaceProps {
  isSessionActive: boolean;
  error: AppError | null;
  isConnected: boolean;
  onStartCall: () => void;
  onEndCall: () => void;
}

export function CallInterface({
  isSessionActive,
  error,
  isConnected,
  onStartCall,
  onEndCall
}: CallInterfaceProps) {
  const isCallDisabled = !isConnected || !!error;

  return (
    <div className="space-y-6">
      {/* Primary Call Control */}
      <div className="flex flex-col items-center space-y-3">
        {!isSessionActive ? (
          <>
            <button
              onClick={onStartCall}
              disabled={isCallDisabled}
              className={`w-20 h-20 rounded-full flex items-center justify-center transition-all duration-300 relative ${
                isCallDisabled
                  ? 'bg-gray-600 text-gray-400 cursor-not-allowed opacity-50'
                  : 'btn-success hover:scale-110 active:scale-95 shadow-lg hover:shadow-xl'
              }`}
              title="Start voice call"
            >
              <Phone className="w-7 h-7" />
              {!isCallDisabled && (
                <div className="absolute inset-0 rounded-full bg-green-400 opacity-20 animate-ping"></div>
              )}
            </button>
          </>
        ) : (
          <>
            <button
              onClick={onEndCall}
              className="w-20 h-20 rounded-full btn-danger hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center shadow-lg hover:shadow-xl relative"
              title="End call"
            >
              <PhoneOff className="w-7 h-7" />
              <div className="absolute inset-0 rounded-full bg-red-400 opacity-20 animate-pulse"></div>
            </button>
          </>
        )}
      </div>
    </div>
  );
} 